import apiClient from '../../../utils/clients/axios'

export const
    MaterialInwardEntry = async (payload) => {
        const response = await apiClient.post(
            '/materialinward/',
            payload, {
            headers: {
                'Content-Type': 'application/json'
            }
        }
        )

        return response
    }

export const getMaterialData = async () => {
    const { data } = await apiClient.get('/materialinward/queue/')

    console.log({ data })

    return data
}

export const updateMaterialInwardStatus = async (id) => {
    console.log({ id })
    const response = await apiClient.patch(`/materialinward?id=${id}`, {
        'status': 'OUT'
    })

    return response;
}